import {TUTORIAL} from "utils/constants";

const initialState = {
  isOpened: false,
  isListOpened: false,
  contentsId: "",
  missionIdx: 0,
  completedMissionIdx: -1,
  project: {},
};

const tutorial = (state = initialState, action) => {
  switch (action.type) {
    case TUTORIAL.INIT_TUTORIAL:
      return {
        ...state,
        isOpened: true,
        contentsId: action.payload.contentsId,
        missionIdx: action.payload.missionIdx,
        completedMissionIdx: action.payload.missionIdx - 1,
      };
    case TUTORIAL.HANDLE_TUTORIAL_PANEL:
      return {
        ...state,
        isOpened: !state.isOpened,
      };
    case TUTORIAL.HANDLE_TUTORIAL_LIST:
      return {
        ...state,
        isListOpened: !state.isListOpened,
      };
    case TUTORIAL.HANDLE_TUTORIAL_MISSION:
      return {
        ...state,
        missionIdx: action.payload,
      };
    case TUTORIAL.HANDLE_TUTORIAL_COMPLETED_MISSION_IDX:
      return {
        ...state,
        completedMissionIdx: action.payload,
      };
    case TUTORIAL.GET_MY_PROJECT_INFO:
      return {
        ...state,
        project: action.payload,
      };
    default:
      return state;
  }
};

export default tutorial;
